module.exports = __webpack_public_path__ + "static/media/frankHendrickx.d8bd6f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/frankHendrickx.jpg
// module id = 1566
// module chunks = 1